import React from 'react'; 
import Pagify from 'react-pagify';
import segmentize from 'segmentize';
import pagifyBootstrapPreset from 'react-pagify-preset-bootstrap';


const Paginator = ({ pagination, pages, onSelect, prevText = 'Précédent', nextText = 'Suivant' }) => (
  <div className="pagination">
    <Pagify.Context
      {...pagifyBootstrapPreset}
      className="pagination"
      segments={segmentize({
        page: pagination.page,
        pages,
        beginPages: 3,
        endPages: 3,
        sidePages: 2
      })} onSelect={onSelect}
    >
      <Pagify.Button page={pagination.page - 1}>{prevText}</Pagify.Button>

      <Pagify.Segment field="beginPages" />

      <Pagify.Ellipsis
        className="ellipsis"
        previousField="beginPages"
        nextField="previousPages"
      />

      <Pagify.Segment field="previousPages" />
      <Pagify.Segment field="centerPage" className="active" />
      <Pagify.Segment field="nextPages" />

      <Pagify.Ellipsis
        className="ellipsis"
        previousField="nextPages"
        nextField="endPages"
      />

      <Pagify.Segment field="endPages" />

      <Pagify.Button page={pagination.page + 1}>{nextText}</Pagify.Button>
    </Pagify.Context>
  </div>
);


export default Paginator;